export default "__VITE_ASSET__CDDVc4hc__"